import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "typeface-roboto";

import store from "./store";
import SocketService from "./services/SocketService";
import App from "./App";

import "./styles/app.css";
import "./styles/Badge.css";

const _socketService = new SocketService();
_socketService.connect();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root") as HTMLElement
);
